import React, { useEffect, useState, useCallback } from 'react';
import './SecondaryNavbar.css';
 
const NAV_LINKS = [
  { href: '#dienstleistungen', label: 'Dienstleistungen' },
  { href: '#projekte',         label: 'Projekte'         },
  { href: '#traumgarten',      label: 'Traumgarten'      },
  { href: '#über-uns',         label: 'Über uns'         },
  { href: '#bewertungen',      label: 'Bewertungen'      },
];
 
function SecondaryNavbar() {
  const [scrolled,    setScrolled]    = useState(false);
  const [menuOpen,    setMenuOpen]    = useState(false);
  const [activeLink,  setActiveLink]  = useState('');
 
  // ── Scroll → add .scrolled class ──
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
 
  // ── Close drawer on resize to desktop ──
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 860) setMenuOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
 
  // ── Lock body scroll when drawer is open ──
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);
 
  // ── IntersectionObserver: highlight active section ──
  useEffect(() => {
    const sectionIds = NAV_LINKS.map(l => l.href.replace('#', ''));
    const observers = [];
 
    sectionIds.forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveLink(`#${id}`); },
        { threshold: 0.35 }
      );
      obs.observe(el);
      observers.push(obs);
    });
 
    return () => observers.forEach(o => o.disconnect());
  }, []);
 
  const handleLinkClick = useCallback((href) => {
    setMenuOpen(false);
    setActiveLink(href);
  }, []);
 
  return (
    <>
      <header className={`secondary-navbar${scrolled ? ' scrolled' : ''}`}>
        <nav className="secondary-bottom-bar" aria-label="Hauptnavigation">
 
          {/* Logo */}
          <div className="brand">
            <a href="#top" aria-label="EG-Bau – zur Startseite">
              <img
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="EG-BAU Logo"
              />
            </a>
          </div>
 
          {/* Desktop links */}
          <ul className="secondary-nav-links" role="list">
            {NAV_LINKS.map(({ href, label }) => (
              <li key={href}>
                <a
                  href={href}
                  className={`secondary-nav-link${activeLink === href ? ' active-link' : ''}`}
                  onClick={() => handleLinkClick(href)}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
 
          {/* Desktop CTA */}
          <div className="actions">
            <a href="#contact" className="request-button">
              <span>Anfrage stellen</span>
            </a>
          </div>
 
          {/* Mobile hamburger */}
          <button
            className={`nav-hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label={menuOpen ? 'Menü schließen' : 'Menü öffnen'}
            aria-expanded={menuOpen}
            aria-controls="mobile-drawer"
          >
            <span />
            <span />
            <span />
          </button>
        </nav>
      </header>
 
      {/* Mobile drawer */}
      <div
        id="mobile-drawer"
        className={`nav-mobile-drawer${menuOpen ? ' open' : ''}`}
        role="dialog"
        aria-label="Mobile Navigation"
        aria-hidden={!menuOpen}
      >
        {NAV_LINKS.map(({ href, label }) => (
          <a
            key={href}
            href={href}
            onClick={() => handleLinkClick(href)}
          >
            {label}
          </a>
        ))}
        <a href="#contact" onClick={() => setMenuOpen(false)}>
          Anfrage stellen
        </a>
      </div>
    </>
  );
}
 
export default SecondaryNavbar;
 